import React, { useContext, useState } from "react"
import { SimpleBillingData, useCurrentBillingInfo } from "../hooks/useCurrentBillingInfo"
import { assert } from "@cd2/tools"
import { DelayedRender } from "../interfaceParts/DelayedRender"
import { Frame } from "../interfaceParts/Frame"
import { Spinner } from "@cd2/components"

type IContextValue = {
  onBillingStatusUpdate: () => void
  billingData: SimpleBillingData
  reloadKey: number
}

export const BillingStatusContext = React.createContext<IContextValue | null>(null)

export function useBillingStatus() {
  const value = useContext(BillingStatusContext)
  assert(value, "useBillingStatus must be used inside BillingStatusProvider")
  return value
}

export function BillingStatusProvider(props: { children: React.ReactNode }) {
  const [reloadKey, setReloadKey] = useState(1)
  const data = useCurrentBillingInfo([reloadKey])

  if (!data) {
    return (
      <Frame minHeight={300}>
        <DelayedRender>
          <Spinner color="black" />
          <DelayedRender timeoutMs={3000}>
            Something seems to be taking longer than expected. If this issue persists, please
            contact support.
          </DelayedRender>
        </DelayedRender>
      </Frame>
    )
  }

  return (
    <BillingStatusContext.Provider
      value={{
        billingData: data,
        onBillingStatusUpdate: () => {
          setReloadKey(old => old + 1)
        },
        reloadKey,
      }}
    >
      {props.children}
    </BillingStatusContext.Provider>
  )
}
